import React from "react";
import styles from "./CityCard.module.css";

const CityCard = ({ city, users }) => {
  return (
    <div className={styles.cityRow}>
      <div className={styles.cityName}>{city}</div>
      <div className={styles.cityUsers}>{users}</div>
    </div>
  );
};

export default CityCard;
